module.exports = __webpack_public_path__ + "img/lg_ring_g_0_null_0@2x.ba128814.png";